import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Alert } from '@app/core/interfaces/alert-interface';

@Injectable()
export class AlertService {

  private alertStream$ = new BehaviorSubject<Alert>(null);

  showAlert(alert: Alert) {
    this.alertStream$.next(alert);
  }

  getErrorStream(): Observable<Alert> {
    return this.alertStream$.asObservable();
  }
}
